<template>
  <v-container :style="`${currentCustomAnalytic && currentCustomAnalytic.style && `max-width: ${currentCustomAnalytic.style.width}px`}`">
    <report-list v-if="isBaseRoute" />

    <connected-app
      v-else-if="currentCustomAnalytic"
      :custom-analytic="currentCustomAnalytic"
      :hide-tabs="false"
      toolbar="top"
    />

    <div v-else>
      <span>Loading ...</span>
    </div>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapGetters: mapToolsGetters, mapState: mapToolsState } = createNamespacedHelpers('tools')

export default {
  name: 'CustomAnalytics',
  components: {
    ConnectedApp: () => import('src/custom-analytics/components/ConnectedApp'),
    ReportList: () => import('src/custom-analytics/components/ReportList'),
  },
  computed: {
    ...mapToolsState({
      baseReportName: (state) => state.baseReportName,
    }),
    ...mapToolsGetters(['currentCustomAnalytic']),
    isBaseRoute() {
      return !this.baseReportName || this.baseReportName === 'reportlist'
    },

  },
}
</script>
